import { useParams, useNavigate } from "react-router-dom";

/* TEMP DATA */
const partners = [
  {
    id: 1,
    service: "Salon",
    businessName: "Style Hub Salon",
    address: "MG Road, Bangalore",
    city: "Bangalore",
    mobile: "9999999999",
    experience: "5 Years",
    rating: "4.6"
  },
  {
    id: 2,
    service: "Salon",
    businessName: "Glow Beauty Salon",
    address: "Andheri West",
    city: "Mumbai",
    mobile: "8888888888",
    experience: "3 Years",
    rating: "4.4"
  }
];

function PartnerDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const partner = partners.find(
    (p) => p.id === parseInt(id)
  );

  if (!partner) return <p>Partner not found</p>;

  return (
    <div className="partner-detail-page">
      <h2>{partner.businessName}</h2>

      <p><b>Service:</b> {partner.service}</p>
      <p><b>Address:</b> {partner.address}, {partner.city}</p>
      <p><b>Experience:</b> {partner.experience}</p>
      <p><b>Rating:</b> ⭐ {partner.rating}</p>
      <p><b>Contact:</b> {partner.mobile}</p>

      <div style={{ marginTop: 20 }}>
        <button
          className="top-btn"
          onClick={() => navigate(`/book/${partner.id}`)}
        >
          Book Service
        </button>
      </div>
    </div>
  );
}

export default PartnerDetail;
